import type {
  PlatformProviderKeyProvider,
  PlatformProviderModelDefinition,
  VelugaModelCatalogItem,
} from '../../types.js';

const WEB_SEARCH_PROVIDERS = new Set<PlatformProviderKeyProvider>([
  'openai',
  'anthropic',
  'gemini',
  'minimax',
]);

export function supportsManualNativeWebSearch(
  provider: PlatformProviderKeyProvider
): boolean {
  return WEB_SEARCH_PROVIDERS.has(provider);
}

export function manualNativeWebSearchEnabled(
  capabilities: PlatformProviderModelDefinition['capabilities']
): boolean {
  return (
    capabilities.webSearchNativeProvider !== undefined ||
    capabilities.webSearchToolFallback === true
  );
}

export function otherProviderDefault(
  models: PlatformProviderModelDefinition[],
  provider: PlatformProviderKeyProvider,
  selectedModelKey?: string
): PlatformProviderModelDefinition | undefined {
  return models.find(
    (model) =>
      model.provider === provider &&
      model.modelKey !== selectedModelKey &&
      model.defaultForProvider
  );
}

export function manualRoutingSafety(
  enabled: boolean,
  safety: VelugaModelCatalogItem['routing']['safety']
): VelugaModelCatalogItem['routing']['safety'] | undefined {
  return enabled
    ? {
        allowAdaptiveForRisk: [...new Set(safety.allowAdaptiveForRisk)],
        disallowForDataClassifications: [
          ...new Set(safety.disallowForDataClassifications),
        ],
        requireStrongForFinalAnswer: safety.requireStrongForFinalAnswer,
        requireStrongForCompliance: safety.requireStrongForCompliance,
      }
    : undefined;
}
